import { useState } from "react";
import { X, Loader2 } from "lucide-react";
import { api, formatApiError } from "../../lib/api";
import { toast } from "sonner";

const inputCls = "border border-brand-line rounded-xl px-4 py-2.5 w-full focus:ring-2 focus:ring-brand-accent focus:border-brand-accent outline-none bg-white text-brand-ink";

export function ChangePasswordModal({ onClose }) {
  const [current, setCurrent] = useState("");
  const [next, setNext] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const save = async () => {
    setError("");
    if (next.length < 6) return setError("Le nouveau mot de passe doit contenir au moins 6 caractères.");
    if (next !== confirm) return setError("La confirmation ne correspond pas.");
    setLoading(true);
    try {
      await api.post("/auth/change-password", { current_password: current, new_password: next });
      toast.success("Mot de passe modifié");
      onClose();
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail) || err.message);
    } finally { setLoading(false); }
  };

  return (
    <div className="fixed inset-0 z-[60] flex items-center justify-center p-4 bg-black/40" onClick={onClose}>
      <div className="bg-white rounded-2xl w-full max-w-md p-6" onClick={(e) => e.stopPropagation()}>
        <div className="flex items-center justify-between mb-4">
          <h3 className="font-heading font-bold text-xl text-brand-ink">Changer mon mot de passe</h3>
          <button onClick={onClose} className="p-1.5 hover:bg-brand-cream rounded-full"><X className="w-5 h-5" /></button>
        </div>
        <div className="space-y-3">
          <input data-testid="current-password" type="password" className={inputCls} placeholder="Mot de passe actuel" value={current} onChange={(e) => setCurrent(e.target.value)} />
          <input data-testid="new-password" type="password" className={inputCls} placeholder="Nouveau mot de passe (min. 6)" value={next} onChange={(e) => setNext(e.target.value)} />
          <input data-testid="confirm-password" type="password" className={inputCls} placeholder="Confirmer le nouveau mot de passe" value={confirm} onChange={(e) => setConfirm(e.target.value)} />
          {error && <p className="text-sm text-brand-secondary" data-testid="change-password-error">{error}</p>}
          <button onClick={save} disabled={loading} data-testid="save-password-button" className="w-full bg-brand text-white hover:bg-brand-hover rounded-full px-6 py-3 font-semibold flex items-center justify-center gap-2 disabled:opacity-60">
            {loading ? <Loader2 className="w-5 h-5 animate-spin" /> : "Enregistrer"}
          </button>
        </div>
      </div>
    </div>
  );
}
